import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';

import { allGamesSelector, clearSelectedItems } from 'store/slices/allGames';

import { getStorageData, setStorageData } from 'utils/storage/allGames';

import Content from 'components/pages/AllGames/Content/Content';
import Download from 'components/pages/AllGames/Download/Download';
import Filters from 'components/pages/AllGames/Filters/Filters';
import Search from 'components/pages/AllGames/Search/Search';
import SortBy from 'components/pages/AllGames/SortBy/SortBy';
import ViewType from 'components/pages/AllGames/ViewType/ViewType';

import { VISIBLE_LIMIT } from 'components/config/games';

import styles from './AllGames.module.scss';

const AllGames = () => {
  const dispatch = useDispatch();

  const [viewType, setViewType] = useState(getStorageData().viewType);
  const [visibleCount, setVisibleCount] = useState(VISIBLE_LIMIT);

  const isVisible = useSelector(allGamesSelector.getVisible);

  const handleChangeViewType = useCallback(
    (type) => {
      if (type !== viewType) {
        setViewType(type);
        visibleCount !== VISIBLE_LIMIT && setVisibleCount(VISIBLE_LIMIT);

        setStorageData({ viewType: type });
      }
    },
    [viewType, visibleCount],
  );

  useEffect(() => {
    return () => dispatch(clearSelectedItems());
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapperHeader}>
        <div className={styles.wrapperFilters}>
          <div
            className={classNames(styles.filters, {
              [styles.filtersHide]: !isVisible,
            })}
          >
            <Filters />
          </div>
        </div>
        <div className={styles.wrapperActions}>
          <div className={styles.content}>
            <Download />
            <div className={styles.wrapperSort}>
              <Search />
              <SortBy />
              <ViewType value={viewType} handleChange={handleChangeViewType} />
            </div>
          </div>
        </div>
      </div>
      <Content
        viewType={viewType}
        visibleCount={visibleCount}
        setVisibleCount={setVisibleCount}
      />
    </div>
  );
};

export default AllGames;
